import { palette } from '@hapana/shared/web/styles/material-ui/palette'

/**
 * Hapana's look and feel, expressed in Stripe Connect's appearance vocabulary.
 *
 * Connect renders each embedded component inside an iframe, so none of our CSS reaches it —
 * these variables plus the loaded font are the only way to style it, and anything left unset
 * falls back to Stripe's own blue-and-system-font defaults, which read as a foreign panel
 * dropped into the page.
 *
 * @see https://docs.stripe.com/connect/embedded-appearance-options
 */

/** Outfit, loaded from the same Google Fonts stylesheet as `web/core/index.html`. */
export const CAPITAL_FONT_CSS_SRC =
  'https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap'

const FONT_FAMILY = "Outfit, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif"

export const capitalAppearance = {
  variables: {
    fontFamily: FONT_FAMILY,
    fontSizeBase: '14px',
    spacingUnit: '8px',
    borderRadius: '8px',
    buttonBorderRadius: '8px',
    formBorderRadius: '8px',
    badgeBorderRadius: '4px',
    overlayBorderRadius: '8px',

    colorPrimary: palette.primary.main,
    colorBackground: palette.gray[0],
    colorText: palette.gray[100],
    colorSecondaryText: palette.gray[64],
    colorBorder: palette.hierarchy.border,
    colorDanger: palette.error.main,
    offsetBackgroundColor: palette.gray[3],
    formBackgroundColor: palette.gray[0],
    formAccentColor: palette.primary.main,
    formHighlightColorBorder: palette.primary.main,
    formPlaceholderTextColor: palette.gray[56],

    // Primary actions follow the brand colour rather than Stripe blue.
    buttonPrimaryColorBackground: palette.primary.main,
    buttonPrimaryColorBorder: palette.primary.main,
    buttonPrimaryColorText: palette.gray[0],
    buttonSecondaryColorBackground: palette.gray[3],
    buttonSecondaryColorBorder: palette.hierarchy.border,
    buttonSecondaryColorText: palette.gray[100],
    buttonLabelFontWeight: '600',
    actionPrimaryColorText: palette.primary.main,

    // Mirrors shared/web/styles/material-ui/typography.js: headings 600, body 400.
    headingXlFontSize: '24px',
    headingXlFontWeight: '600',
    headingLgFontSize: '20px',
    headingLgFontWeight: '600',
    headingMdFontSize: '16px',
    headingMdFontWeight: '600',
    headingSmFontSize: '14px',
    headingSmFontWeight: '600',
    headingXsFontSize: '12px',
    headingXsFontWeight: '600',
    bodyMdFontSize: '14px',
    bodyMdFontWeight: '400',
    bodySmFontSize: '12px',
    bodySmFontWeight: '400',
    labelMdFontSize: '14px',
    labelMdFontWeight: '400',
    labelSmFontSize: '12px',
    labelSmFontWeight: '400',

    badgeSuccessColorBackground: palette.success.lightest,
    badgeSuccessColorText: palette.success.dark,
    badgeWarningColorBackground: palette.warning.lightest,
    badgeWarningColorText: palette.warning.dark,
    badgeDangerColorBackground: palette.error.lightest,
    badgeDangerColorText: palette.error.dark,
    badgeNeutralColorBackground: palette.gray[8],
    badgeNeutralColorText: palette.gray[80],
  },
}
